// extracted by mini-css-extract-plugin
export default {"estimateHeaderBadges":"EstimateForm_estimateHeaderBadges__xX8bE"};